const NAV_SELECTOR = '[class~="#product-subnav"]';
const HEADER_SECTION_SELECTOR = '.shopify-section-group-header-group';
const PRODUCT_ANCHOR_SELECTOR = '#pdp-anchor-product';
const REVIEWS_ANCHOR_SELECTOR = '#pdp-anchor-reviews';
const MOBILE_MQ = window.matchMedia('(max-width: 991px)');

const nav = document.querySelector(NAV_SELECTOR);
if (!nav) {
  // not a PDP or snippet not rendered
} else {
  const productBtn = nav.querySelector('[data-target="product"]');
  const reviewBtn = nav.querySelector('[data-target="reviews"]');
  const resolveProductAnchor = () =>
    document.querySelector(PRODUCT_ANCHOR_SELECTOR) ||
    document.querySelector('[id^="productPageContainer"]');

  let productAnchor = resolveProductAnchor();
  let reviewsAnchor = document.querySelector(REVIEWS_ANCHOR_SELECTOR);

  let offsetTicking = false;
  let scrollTicking = false;
  let spyObserver = null;

  const readCssPx = (name) => {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    const value = parseFloat(raw);
    return Number.isFinite(value) ? value : 0;
  };

  const getHeaderBottom = () => {
    let bottom = 0;

    document.querySelectorAll(HEADER_SECTION_SELECTOR).forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.height > 0 && rect.top <= 2) {
        bottom = Math.max(bottom, rect.bottom);
      }
    });

    if (bottom > 0) return Math.ceil(bottom);

    const mainHeader = document.querySelector('[id^="mainHeader"]');
    if (mainHeader) {
      const rect = mainHeader.getBoundingClientRect();
      if (rect.height > 0) return Math.ceil(rect.bottom);
    }

    return Math.ceil(
      readCssPx('--header-height') +
      readCssPx('--navbar-height') +
      readCssPx('--utility-bar-height')
    );
  };

  const getNavHeight = () => Math.ceil(nav.getBoundingClientRect().height) || 48;

  const getScrollOffset = () => getHeaderBottom() + getNavHeight() + 8;

  const syncHeaderOffset = () => {

    const headerBottom = getHeaderBottom();
    const navHeight = getNavHeight();

    document.documentElement.style.setProperty('--pdp-subnav-top', `${headerBottom}px`);
    document.documentElement.style.setProperty('--pdp-subnav-height', `${navHeight}px`);
  };

  const scheduleOffsetSync = () => {
    if (offsetTicking) return;
    offsetTicking = true;
    requestAnimationFrame(() => {
      syncHeaderOffset();
      offsetTicking = false;
    });
  };

  const setActive = (target) => {
    productBtn?.classList.toggle('!active', target === 'product');
    reviewBtn?.classList.toggle('!active', target === 'reviews');
  };

  const scrollToTarget = (target) => {
    const el = target === 'product' ? productAnchor : reviewsAnchor;
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setActive(target);
  };

  const syncReviewVisibility = () => {
    productAnchor = resolveProductAnchor();
    reviewsAnchor = document.querySelector(REVIEWS_ANCHOR_SELECTOR);

    if (!reviewsAnchor) {
      if (reviewBtn) reviewBtn.hidden = true;
      productBtn?.classList.add('!solo');
      setActive('product');
      return;
    }

    if (reviewBtn) reviewBtn.hidden = false;
    productBtn?.classList.remove('!solo');
  };

  const updateActiveFromScroll = () => {
    if (!productAnchor) return;


    const offset = getScrollOffset();

    if (reviewsAnchor && reviewBtn && !reviewBtn.hidden) {
      if (reviewsAnchor.getBoundingClientRect().top <= offset) {
        setActive('reviews');
        return;
      }
    }

    setActive('product');
  };

  const scheduleScrollUpdate = () => {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(() => {
      syncHeaderOffset();
      updateActiveFromScroll();
      scrollTicking = false;
    });
  };

  const bindSpy = () => {
    spyObserver?.disconnect();
    spyObserver = null;

    if (!MOBILE_MQ.matches || !productAnchor) return;

    const marginTop = -getScrollOffset();
    spyObserver = new IntersectionObserver(
      () => scheduleScrollUpdate(),
      {
        root: null,
        rootMargin: `${marginTop}px 0px -55% 0px`,
        threshold: 0
      }
    );

    spyObserver.observe(productAnchor);
    if (reviewsAnchor && reviewBtn && !reviewBtn.hidden) {
      spyObserver.observe(reviewsAnchor);
    }
  };

  productBtn?.addEventListener('click', () => scrollToTarget('product'));
  reviewBtn?.addEventListener('click', () => scrollToTarget('reviews'));

  window.addEventListener('scroll', scheduleScrollUpdate, { passive: true });
  window.addEventListener('resize', () => {
    scheduleOffsetSync();
    bindSpy();
    scheduleScrollUpdate();
  });
  MOBILE_MQ.addEventListener('change', () => {
    scheduleOffsetSync();
    bindSpy();
    scheduleScrollUpdate();
  });

  const init = () => {
    syncReviewVisibility();
    scheduleOffsetSync();
    bindSpy();
    scheduleScrollUpdate();
  };

  init();
  window.addEventListener('load', init);

  const domObserver = new MutationObserver(() => {
    syncReviewVisibility();
    bindSpy();
    scheduleOffsetSync();
  });
  domObserver.observe(document.body, { childList: true, subtree: true });
}
